import React, {useState } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';

import { Box, Button} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import EnhancedTable from '../../Shared/EnhancedTable/EnhancedTable';
import { tableStyles } from './../CaseDashboard.style';
import RecordsDocumentsDialog from './RecordsDocumentsDialog/RecordsDocumentsDialog';
import RecordChronologyMenu from './RecordChronolgyMenu/RecordChronologyMenu';

const headCells = [
  { id: "partNumber", label: "PartNo/RefNo", width: "10%" },
  { id: 'locationName', label: 'Location Name', width: '20%' },
  { id: 'recordType', label: 'Record Type', width: '12%' },
  { id: 'records', label: 'Records', width: '12%' }
];

const CaseRecords = (props) => {
  const {
    classes,
    expertRecordsList = [],
    orderNumber,
    isLoading,
    claimantName,
    isDownloadAllowed,
    hasChronologyFile,
    orderId
  } = props;

  const [openDialog, setOpenDialog] = useState(false);
  const [recordInfo, setRecordInfo] = useState(null);

  // action buttons
  function ViewButton(props) {
    const { classes, row, orderId } = props;

   const handleButtonClick = ()=>{ 
     const recordInfo = {
       orderId: orderId,
       orderRecordId : row['id'],
       orderNumber: orderNumber,
       headerData:[{value: claimantName, label:"Record Of"},{value:row['locationName'],label:"Location Name"},{value:row['recordType'], label:"Record Type"}],
      }
       
       setRecordInfo(recordInfo);
       setOpenDialog(true);
  };
  
    return (
      <div className={classes.viewSection}>
        <Button
          data-testid="caseRecordOpenButton"
          variant="contained"
          size="small"
          className={classes.viewBtn}
          onClick={handleButtonClick}>
          Open
        </Button>
      </div>
    );
  }

  ViewButton.propTypes = {
    classes: PropTypes.object.isRequired,
    row: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      locationName: PropTypes.string,
      recordType: PropTypes.string
    }), // Not required here because it's provided by EnhancedTable at runtime
    orderId: PropTypes.string.isRequired // GUID from C#
  };

  const customCells = {
    records: <ViewButton classes={classes} orderId={orderId} />
  };

  return (
    <div>
      <Paper elevation={0} className={classes.tableTitle}>
      <Box display={'flex'} justifyContent={"space-between"}>
        Records
      {hasChronologyFile && 
        <RecordChronologyMenu
        orderId={orderId}
        isDownloadAllowed = {isDownloadAllowed}
        orderNumber={orderNumber}
        />
      }
      </Box>
      </Paper>
      <EnhancedTable
        rows={expertRecordsList}
        headCells={headCells}
        customCells={customCells}
        rowsPerPageOptions={[]}
        showPagination
        pageCount={5}
        isLoading={isLoading}
        rowKey="id"
      />
  
      <RecordsDocumentsDialog 
     	      title="Shared Records"
            id="record-documents-dialog"
            isDownloadAllowed= {isDownloadAllowed}
            open= {openDialog}
            setOpen={setOpenDialog}
            recordsInfo = {recordInfo}/>
    </div>
  );
};

CaseRecords.propTypes = {
  classes: PropTypes.object.isRequired,
  expertRecordsList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      partNumber: PropTypes.string,
      locationName: PropTypes.string,
      recordType: PropTypes.string
    })
  ),
  orderNumber: PropTypes.string.isRequired, // String from C#
  isLoading: PropTypes.bool,
  claimantName: PropTypes.string.isRequired,
  isDownloadAllowed: PropTypes.bool,
  hasChronologyFile: PropTypes.bool,
  orderId: PropTypes.string.isRequired // GUID from C#
};

CaseRecords.defaultProps = {
  expertRecordsList: [],
  isLoading: false,
  isDownloadAllowed: true,
  hasChronologyFile: false
};

export default withStyles(tableStyles)(CaseRecords);
